import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

interface Props {
  type?: string;
  children: React.ReactNode;
  disabled?: boolean;
  block?: boolean;
  onClick?(): void;
}

export const Button = (props: Props) => {
  const { children, type = 'default', disabled = false, block = false, onClick } = props;

  const cls = classNames(styles.button, {
    [`${styles.btnDefault}`]: type === 'default',
    [`${styles.btnPrimary}`]: type === 'primary',
    [`${styles.disable}`]: disabled,
    [`${styles.block}`]: block,
  });

  const handleClick = () => {
    onClick?.();
  };

  return (
    <button className={cls} onClick={handleClick} disabled={disabled}>
      {children}
    </button>
  );
};
